import React, { useState } from 'react'
// import profileImg from "../../Assets/images/pro-pic.jpg";
import { api_url } from '../../Constants/web_services';
import { Link } from 'react-router-dom';


const AboutProvider = ({ company }) => {
    const [companyData] = useState(company);



    const StarRating = ({ rating }) => {
        const fullStars = Math.floor(rating); // Number of full stars
        const emptyStars = 5 - fullStars; // Number of empty stars

        const starElements = [];

        // Add full star elements
        for (let i = 0; i < fullStars; i++) {
            starElements.push(<span key={i} className="fa fa-star" style={{ fontSize: '25px' }} />);
        }

        // Add empty star elements
        for (let i = 0; i < emptyStars; i++) {
            starElements.push(<span key={fullStars + i} className="fa fa-star text-danger" style={{ fontSize: '20px' }} />);
        }

        return <div className="sf-ow-pro-rating">{starElements}</div>;
    };
    return (
        <>
            <div className="container" style={{ height: "570px" }} id='aon-provider-about'>
                {/*About Provider*/}
                <div className="sf-provi-bio-box cleafix margin-b-50 sf-provi-fullBox" >
                    {/*Left*/}
                    <div className="sf-provi-bio-left">
                        <div className=" p-0">
                            {/*<div className=" mb-3 media-bg-animate">
                            <img src={api_url+'/'+companyData?.logo} alt="" />
                              
                            </div>
                            <div className="">
                                <span className="elem pic-long text-decoration-none text-uppercase" >
                                  <h3 className="sf-provi-title fw-700 text-drk-primary">{companyData?.name}</h3>
                                </span>
                                
                            </div>
                            <div className="sf-ow-pro-rating text-warning" >
                            <StarRating rating={companyData?.rating}  />
                            </div>*/}
                            <div className="owl-item active" style={{ width: '350px', marginRight: '20px' }}><div className="item">
                                <div className="aon-ow-provider-wrap">
                                    <div className="aon-ow-provider shine-hover">
                                        <div className="aon-ow-top">
                                            <div className="aon-pro-check"><span><i className="fa fa-check" /></span></div>
                                            {/* <div className="aon-pro-favorite"><a href="/"><i className="fa fa-heart-o" /></a></div> */}
                                            <div className="aon-ow-info">
                                                <h4 className="aon-title text-uppercase">{companyData?.name}</h4>
                                                <span>{companyData?.office_location}</span>
                                            </div>
                                        </div>
                                        <div className="aon-ow-mid">
                                            <div className="aon-ow-media media-bg-animate">
                                                <div className="shine-box">
                                                    <img src={api_url + '/' + companyData?.logo} style={{ maxWidth: "230px", maxHeight: "250px" }} alt="2" />
                                                </div>
                                            </div>
                                            <p>Through our expertise, technological knowledge, global presence and bespoke.</p>
                                            <div className="aon-ow-pro-rating">
                                                <StarRating rating={companyData?.rating} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="aon-ow-bottom">
                                        {/* <a href="profile-full.html">Request A Quote</a> */}
                                    </div>
                                </div>
                            </div></div>
                        </div>

                    </div>
                    {/*Right*/}
                    <div className="sf-provi-bio-right">
                        <h3 className="sf-provi-title fw-700 text-drk-primary">About Company</h3>
                        <div className="sf-provi-cat">
                            <strong>Specialities:</strong> Packers and Movers
                        </div>
                        <div className="sf-provi-bio-text  mt-5 border-1"
                        >
                            <p style={{ height: "370px" }}>
                                <strong>Description:</strong>
                                &nbsp;{companyData.description}

                            </p>


                        </div>
                        <div className="sf-provi-social-row d-flex flex-wrap justify-content-between"
                        >
                            <div className="social-share-cell">
                                <strong>Explore Us On Social Media</strong>
                            </div>
                            <div className="sf-provi-social">
                                <ul className="share-social-bx">
                                    <li className="fb">
                                        <Link target='_blank' to={(companyData?.fb_link)}>
                                            {" "}
                                            <i className="fa fa-facebook" /> Share
                                        </Link>
                                    </li>
                                    <li className="insta ">
                                        <Link target='_blank' to={companyData?.insta_link}>
                                            {" "}
                                            <i className="fa fa-instagram" /> Share{" "}
                                        </Link>
                                    </li>
                                    <li className="lin">
                                        <Link target='_blank' to={companyData?.linkedin_link}>
                                            {" "}
                                            <i className="fa fa-linkedin" /> Share{" "}
                                        </Link>
                                    </li>
                                    {/* <li className="pin">
                                        <Link to={companyData?.fb_link}>
                                            {" "}
                                            <i className="fa fa-pinterest" /> Share{" "}
                                        </Link>
                                    </li> */}
                                    {/* <li className="gp">
                                        <a href="javascript:;">
                                            {" "}
                                            <i className="fa fa-google-plus" /> Share{" "}
                                        </a>
                                    </li> */}
                                    {/* <li className="dig">
                                        <a href="javascript:;">
                                            {" "}
                                            <i className="fa fa-digg" /> Share{" "}
                                        </a>
                                    </li> */}
                                </ul>
                            </div>

                        </div>
                        {/* <div className="sf-divider-line" /> */}
                    </div>
                </div>

            </div>

        </>
    )
}

export default AboutProvider